const Constants = {
    NOTIFY: 'notify',
    INFO: 'info',
    ERROR: 'error',
    SUCCESS: 'success',
};

export { Constants };